// extracted by mini-css-extract-plugin
export default {"fstext":"16px","color-text":"#404040","list":"styles_list__ejoG2","figure":"styles_figure__KqxTv","image":"styles_image__5sYpy","figcaption":"styles_figcaption__z1njE"};